import Vue from 'vue'

export const EventBus = new Vue()


// WEBPACK FOOTER //
// ./app/theme/js/utility/event-bus.js